export default "__VITE_ASSET__s8P7AMiB__"